<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'AppShell' })
</script>

<style scoped lang="scss" src="./app-shell.scss"></style>
